
import { Options, Vue } from 'vue-class-component'
import { maska } from 'maska'
import { Prop, Watch } from 'vue-property-decorator'
import {
  IFlexMessageDatetimePickerAction,
  IFlexMessageMessageAction,
  IFlexMessagePostbackAction,
  IFlexMessageURIAction,
} from '@/utils/types'
import cloneDeep from 'lodash/cloneDeep'
import DateSelectorV2 from '@/components/common/ui/DateSelectorV2.vue'
import DateTimeSelectorV2 from '@/components/common/ui/DateTimeSelectorV2.vue'

@Options({
  components: { DateSelectorV2, DateTimeSelectorV2 },
  directives: { maska },
  emits: ['update:modelValue'],
})
export default class Action extends Vue {
  @Prop()
  modelValue!:
    | IFlexMessagePostbackAction
    | IFlexMessageURIAction
    | IFlexMessageMessageAction
    | IFlexMessageDatetimePickerAction

  @Prop()
  isRequired!: boolean

  @Prop()
  isAdmin!: boolean

  postbackAction: IFlexMessagePostbackAction = {
    type: 'postback',
    label: 'action',
    data: 'hello',
  }

  uriAction: IFlexMessageURIAction = {
    type: 'uri',
    label: 'action',
    uri: 'http://linecorp.com/',
    altUri: {
      desktop: '',
    },
  }

  messageAction: IFlexMessageMessageAction = {
    type: 'message',
    label: 'action',
    text: 'hello',
  }

  dateTimePickerAction: IFlexMessageDatetimePickerAction = {
    type: 'datetimepicker',
    label: 'action',
    data: 'hello',
    mode: 'date',
  }

  get value() {
    return this.modelValue
  }

  set value(
    value:
      | IFlexMessagePostbackAction
      | IFlexMessageURIAction
      | IFlexMessageMessageAction
      | IFlexMessageDatetimePickerAction
      | undefined
  ) {
    this.$emit('update:modelValue', value)
  }

  get actionType() {
    return this.modelValue?.type ?? ''
  }

  set actionType(value: string) {
    if (value === 'postback') {
      this.value = cloneDeep(this.postbackAction)
    } else if (value === 'uri') {
      this.value = cloneDeep(this.uriAction)
    } else if (value === 'message') {
      this.value = cloneDeep(this.messageAction)
    } else if (value === 'datetimepicker') {
      this.value = cloneDeep(this.dateTimePickerAction)
    } else {
      this.value = undefined
    }
  }

  get typeList() {
    return [
      {
        label: '',
        value: '',
      },
      {
        label: 'ポストバック',
        value: 'postback',
      },
      {
        label: 'URI',
        value: 'uri',
      },
      {
        label: 'メッセージ',
        value: 'message',
      },
      {
        label: '日時選択',
        value: 'datetimepicker',
      },
    ]
  }

  get requiredRule() {
    return {
      data: this.$t('validate.this_field_is_required', {
        placeholder: this.$t('label.common.flex_message.data'),
      }),
      uri: this.$t('validate.this_field_is_required', {
        placeholder: this.$t('label.common.flex_message.uri'),
      }),
      text: this.$t('validate.this_field_is_required', {
        placeholder: this.$t('label.common.flex_message.text'),
      }),
    }
  }

  minMaxValidate(mode, min, max) {
    if (!min || !max) return true
    if (mode === 'date') return new Date(min) < new Date(max)
    if (mode === 'time') return this.toMinutes(min) < this.toMinutes(max)
    if (mode === 'datetime') return new Date(min) < new Date(max)
    return false
  }

  toMinutes(timeStr) {
    const [h, m] = timeStr.split(':').map(Number)
    return h * 60 + m
  }

  @Watch('value.mode')
  onChangeMode() {
    if (this.value && 'mode' in this.value) {
      this.value.initial = undefined
      this.value.min = undefined
      this.value.max = undefined
    }
  }

  @Watch('value', { immediate: true, deep: true })
  onValueChanged(val) {
    if (val?.type === 'uri') {
      if (!('altUri' in val)) {
        this.value = {
          ...cloneDeep(this.uriAction),
          ...val,
          altUri: {
            ...cloneDeep(this.uriAction.altUri),
            ...(val.altUri ?? {}),
          },
        }
      } else if (!('desktop' in val.altUri)) {
        this.value = {
          ...val,
          altUri: {
            desktop: '',
          },
        }
      }
    }
  }
}
